<template>
    <div>
        <div class="recent-activity p-4 pb-0">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Tarih</th>
                        <th>Nereden</th>
                        <th>Nereye</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="animal_transaction in animal_transactions">
                        <td>{{ formatDate(animal_transaction.created_at) }}</td>
                        <td>{{ animal_transaction.from_shelter_name }}</td>
                        <td>{{ animal_transaction.to_shelter_name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
    name: 'AnimalTransactions',
    props: {
        animalId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            animal_transactions: [],
        }
    },
    mounted() {

    },
    methods: {
        async fetchAnimalTransactions() {
            try {
                const response = await this.$axios.get(`animal_transaction/?animal=${this.animalId}`);
                this.animal_transactions = response.data.results;
                console.log('Transactions: ', this.animal_transactions);

            } catch (error) {
                console.log(error);
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }

    },
}
</script>